import type { LinkUnitToCourseServiceConfig, UnlinkUnitFromCourseServiceConfig } from '@/services/httpServices/CourseServices/types';
import type {
  DeleteQuizServiceConfig,
  GetQuizByIdServiceConfig,
  QuizListServiceConfig,
  TranslateQuizServiceConfig,
  UpdateQuizServiceConfig,
} from '@/services/httpServices/QuizServices/types';

import { createQueryKey } from './queryKeyUtils';

export function quizListKeys(params?: QuizListServiceConfig) {
  return createQueryKey(['quizList'], params);
}

/**
 * Creates a unique query key for infinite quiz list queries
 * Includes 'infinite' prefix to differentiate from regular list queries
 */
export function infiniteQuizListKeys(params?: QuizListServiceConfig) {
  return ['infinite', ...quizListKeys(params)];
}

export function quizByIdKeys(params?:
  | GetQuizByIdServiceConfig
  | DeleteQuizServiceConfig
  | TranslateQuizServiceConfig
  | UpdateQuizServiceConfig
  | UnlinkUnitFromCourseServiceConfig
  | LinkUnitToCourseServiceConfig) {
  return createQueryKey(['quizById'], params);
}
